export const getDateToday = (date?: string): string => {
  const today = date ? new Date(date) : new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setSeconds(0);
  today.setMilliseconds(0);
  return today.toDateString();
};

export const substractDays = (date: string | Date, days: number): string => {
  const currentDate = new Date(date);
  currentDate.setDate(currentDate.getDate() - days);
  return currentDate.toDateString();
};

export const addDays = (date: string | Date, days: number): string => {
  const currentDate = new Date(date);
  currentDate.setDate(currentDate.getDate() + days);
  return currentDate.toDateString();
};
